import { InputBase } from '@hixme-ui/input'

export default InputBase.withComponent('select').extend`
  box-shadow: '0px 1px 3px 0px rgba(185,197,205,0.50)';
`
